export default __webpack_public_path__ + "static/media/vissights-logo.69bd7634.svg";